import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_MONITOR_APPLICATIONS,
  GET_AZURE_MONITOR_APPLICATIONS_SUCCESS,
  GET_AZURE_MONITOR_APPLICATIONS_ERROR,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS,
  GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR,
} from "./constant";

import {
  getAzureMonitorApplicationsApi,
  getAzureMonitorApplicationParamsApi,
} from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */

function* getAzureMonitorApplicationsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMonitorApplicationsApi, params, provider);
    yield put({
      type: GET_AZURE_MONITOR_APPLICATIONS_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: GET_AZURE_MONITOR_APPLICATIONS_ERROR,
      error,
    });
  }
}

function* getAzureMonitorApplicationsParamsList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMonitorApplicationParamsApi, params, provider);
    yield put({
      type: GET_AZURE_MONITOR_APPLICATIONS_PARAMS_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: GET_AZURE_MONITOR_APPLICATIONS_PARAMS_ERROR,
      error,
    });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureMonitorApplicationsSaga() {
  yield takeLatest(
    GET_AZURE_MONITOR_APPLICATIONS,
    getAzureMonitorApplicationsList
  );
  yield takeLatest(
    GET_AZURE_MONITOR_APPLICATIONS_PARAMS,
    getAzureMonitorApplicationsParamsList
  );
}
